/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Create_Organization_SubtitleInputs */



/**
* | output |
* | --- |
* | "Create a new organization and your admin account" |
*
* @param {Auth_Create_Organization_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_create_organization_subtitle = /** @type {((inputs?: Auth_Create_Organization_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Create_Organization_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstelle eine neue Organisation und dein Admin-Konto")
	return /** @type {LocalizedString} */ ("Create a new organization and your admin account")
});